module.exports = __webpack_public_path__ + "static/media/person1.65b9828f.png";